let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("afUJz")).then(() => parcelRequire('5NHpB'));